import PropTypes from 'prop-types';
import React from 'react';
import StimulusButton from '../../stimulus/StimulusButton';
import { actionOnKeyboardPress } from '../../utils/browserUtils';

export default class AnswerButton extends React.Component {
    componentWillUnmount() {
        this.props.stopPlaying();
    }

    getStyles(type) {
        const buttonStyle = type;
        const statusStyle = this.props.isDisabled ? 'disabled-button' : '';
        const selectedStyle = this.props.isSelected ? 'selected' : '';
        return `${buttonStyle} ${selectedStyle} ${statusStyle} `;
    }

    render() {
        return (
            <div className="comprehension-answer">
                {this.props.hasAudio && (
                    <div
                        className={this.getStyles('speaker-button')}
                        onClick={this.props.onStimulusClick}
                        aria-label="Speaker"
                        onKeyDown={e => actionOnKeyboardPress(e, this.props.onStimulusClick)}
                        tabIndex={this.props.isDisabled ? '-1' : '0'}
                    >
                        <StimulusButton
                            isDisabled={this.props.isDisabled}
                            isPlaying={this.props.isResponsePlaying}
                            onClick={this.props.onStimulusClick}
                        />
                    </div>
                )}

                <div
                    aria-label={`${this.props.letter} ${this.props.text}`}
                    aria-selected={this.props.isSelected}
                    className={this.getStyles('answer-button')}
                    data-testid="answer-button"
                    disabled={!this.props.isEnabled}
                    onKeyDown={e => actionOnKeyboardPress(e, () => this.props.onAnswerClick())}
                    onClick={this.props.onAnswerClick}
                    role="button"
                    tabIndex={this.props.isDisabled ? '-1' : '0'}
                >
                    {!this.props.hasAudio && <div className="letter-box">{this.props.letter}</div>}
                    <div>{this.props.text}</div>
                </div>
            </div>
        );
    }
}

AnswerButton.propTypes = {
    text: PropTypes.string.isRequired,
    hasAudio: PropTypes.bool,
    isSelected: PropTypes.bool,
    isEnabled: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isResponsePlaying: PropTypes.bool,
    onAnswerClick: PropTypes.func.isRequired,
    stopPlaying: PropTypes.func,
    onStimulusClick: PropTypes.func,
    letter: PropTypes.string,
};

AnswerButton.defaultProps = {
    isResponsePlaying: false,
    isSelected: false,
    isEnabled: true,
    isDisabled: false,
    hasAudio: false,
    letter: '',
    stopPlaying: () => {},
    onStimulusClick: () => {},
};
